module.exports = __webpack_public_path__ + "static/img/orange_p.2fd9ce83.png";